import getNestedValue from '@/services/functions/getNestedValue'

/**
 * @typedef {Object} RouteCallbackResult
 * @property {string?} path
 * @property {*} name
 */

/**
 * @typedef {Object} RouteCallback
 * @property {(data: *, breadcrumb: BreadCrumb) => RouteCallbackResult} callback
 */

/**
 * @typedef {Object} DataCallback
 * @property {(entity: *, breadcrumb: BreadCrumb) => string} callback
 */

/**
 * BreadCrumb para componentes genéricos
 */
export default class BreadCrumb {
  /** @type {string?} */ url = '';
  /** @type {string?} */ name = '';
  /** @type {string[]?} */ paths = null;
  /** @type {string} */ separator = ' ';
  /** @type {string?} */ getter = '';
  /** @type {string?} */ setter = '';
  /** @type {boolean} */ forceDynamic = true;
  /** @type {(data: *, breadcrumb: BreadCrumb) => RouteCallbackResult} */ routeCallback = (data, breadcrumb) => ({ path: this.url, name: data });
  /** @type {(entity: *, breadcrumb: BreadCrumb) => string} */ dataCallback = (entity, breadcrumb) => (this.name ? this.name : this.paths?.map(path => getNestedValue(path, entity)).join(this.separator)) || '';
}
